import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Router } from "@angular/router";
import { catchError, finalize, map } from "rxjs/operators";
import { environment } from "src/environments/environment";
import { LacProcess } from "../domain/Lac - EAU/lac-process";
import { CoreData } from "../tools/core-data";
import { LoadingTask } from "../tools/loading-task";
import { BaseService } from "./base-service";
import { MatSnackBar } from "@angular/material/snack-bar";

@Injectable({
    providedIn: 'root',
})
export class LacService extends BaseService {

    private serviceUrl = `${environment.serviceMainBaseUrl}api/LacProcess`;

    constructor(
        protected http: HttpClient,
        protected coreData: CoreData,
        protected loadingTask: LoadingTask,
        protected snackBare: MatSnackBar,
        protected router: Router,
        ) {
            super(coreData, router, snackBare);
    }

    getLacProcessByCode(code: string) {
        this.loadingTask.activateLoading();
        return this.http.get(`${this.serviceUrl}/${code}`, this.generateHeader()).pipe(
            catchError(this.handleError<any>('getLacProcessByCode')),
            finalize(() => this.loadingTask.deactivateLoading()),
            map((response: LacProcess) => {
                return LacProcess.mapFromJSON(response);
            }));
    }

    updateLacProcess(process: LacProcess) {
        this.loadingTask.activateLoading();
        return this.http.put(`${this.serviceUrl}/${process.Code}`, process, this.generateHeader()).pipe(
            catchError(this.handleError<any>('updateLacProcess')),
            finalize(() => this.loadingTask.deactivateLoading()),
            map(x => x));
    }
}